import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const InfinityShape = ({
  width = 16,
  height = 16,
  fillColor = '#FDC93F',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M7.44456 9.05578L9.35405 10.9652L9.35974 10.9595L10.6912 12.291L10.6969 12.2967L12.6415 14.2412C14.4314 16.0312 17.3334 16.0312 19.1232 14.2412C20.9132 12.4513 20.9132 9.54934 19.1232 7.75943C17.3334 5.96951 14.4314 5.96951 12.6415 7.75943L11.9875 8.41337L13.2839 9.70975L13.9378 9.05578C15.0117 7.98185 16.7529 7.98185 17.8269 9.05578C18.9009 10.1298 18.9009 11.8709 17.8269 12.9449C16.7529 14.0188 15.0117 14.0188 13.9378 12.9449L12.0382 11.0453L12.0325 11.0511L8.74092 7.75943C6.95102 5.96951 4.04902 5.96951 2.25912 7.75943C0.46921 9.54934 0.46921 12.4513 2.25912 14.2412C4.04902 16.0312 6.95102 16.0312 8.74092 14.2412L9.39475 13.5873L8.09843 12.291L7.44456 12.9449C6.37062 14.0188 4.62942 14.0188 3.55548 12.9449C2.48154 11.8709 2.48154 10.1298 3.55548 9.05578C4.62942 7.98185 6.37062 7.98185 7.44456 9.05578Z"
      fill={fillColor}
    />
  </svg>
);

export default InfinityShape;
